import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const routes = {
    repairCategoriesPath: () => '/api/RepairCategories/',
    repairCategoriesSearchPropsPath: () => `${routes.repairCategoriesPath()}SearchProperties`,
    repairCategoriesAuditsPathById: (id, params) => `${routes.repairCategoriesPath()}${id}/Audits${getQueryParams(params)}`,
    repairCategoriesAuditPropertiesPathById: (id) => `${routes.repairCategoriesPath()}${id}/Audits/Properties`,
    repairCategoryAuditUsersPathById: (id) => `${routes.repairCategoriesPath()}${id}/Audits/Users`,
    getRepairCategoryPathById: (id) => `${routes.repairCategoriesPath()}${id}`,
    restoreRepairCategoryPathById: (id) => `${routes.repairCategoriesPath()}${id}/restore`,
    deleteRepairCategoryPathById: (id) => `${routes.repairCategoriesPath()}${id}`,
};

export const getRepairCategoriesSearchProps = (params) => makeRequest(authFetch.get(routes.repairCategoriesSearchPropsPath()));

export const getRepairCategories = (params) => makeRequest(authFetch.get(`${routes.repairCategoriesPath()}${getQueryParams(params)}`));

export const getRepairCategory = (id) => makeRequest(authFetch.get(routes.getRepairCategoryPathById(id)));
export const putRepairCategory = (data) => makeRequest(authFetch.put(routes.repairCategoriesPath(), data));

export const deleteRepairCategory = (id) => makeRequest(authFetch.delete(routes.deleteRepairCategoryPathById(id)));
export const restoreRepairCategory = (id) => makeRequest(authFetch.patch(routes.restoreRepairCategoryPathById(id)));

export const getRepairCategoryAudits = (id, params) => makeRequest(authFetch.get(routes.repairCategoriesAuditsPathById(id, params)));
export const getRepairCategoryAuditProperties = (id) => makeRequest(authFetch.get(routes.repairCategoriesAuditPropertiesPathById(id)));
export const getRepairCategoryAuditUsers = (id) => makeRequest(authFetch.get(routes.repairCategoryAuditUsersPathById(id)));
